<template lang="html">
  <div class="select" :class="{ 'select--active': dropdownIsShow }">
    <input type="hidden" v-model="model" />
    <div class="select__label" v-if="label">{{ label }}</div>
    <div
      class="select__selected"
      @click="showDropdown"
      v-click-outside="onClickOutside"
    >
      <span class="select__placeholder" v-if="placeholder && !model">
        {{ placeholder }}
      </span>
      <span class="select__value" v-if="model">{{ model.label }}</span>
      <span class="select__arrow">
        <svg
          width="20"
          height="12"
          viewBox="0 0 20 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M1 1L10 10L19 1" stroke="white" stroke-width="2" />
        </svg>
      </span>
      <svg
        v-if="clear && model"
        class="select__clear"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click.stop="this.$emit('clear-event')"
      >
        <path
          d="M6.22566 4.81096C5.83514 4.42044 5.20197 4.42044 4.81145 4.81096C4.42092 5.20148 4.42092 5.83465 4.81145 6.22517L10.5862 11.9999L4.81151 17.7746C4.42098 18.1651 4.42098 18.7983 4.81151 19.1888C5.20203 19.5793 5.8352 19.5793 6.22572 19.1888L12.0004 13.4141L17.7751 19.1888C18.1656 19.5793 18.7988 19.5793 19.1893 19.1888C19.5798 18.7983 19.5798 18.1651 19.1893 17.7746L13.4146 11.9999L19.1893 6.22517C19.5799 5.83465 19.5799 5.20148 19.1893 4.81096C18.7988 4.42044 18.1657 4.42044 17.7751 4.81096L12.0004 10.5857L6.22566 4.81096Z"
          fill="black"
        />
      </svg>
    </div>
    <transition name="fade">
      <div ref="selectDropdown" v-show="dropdownIsShow" class="select__options">
        <div
          class="select__option"
          v-for="(option, index) in options"
          :key="index"
          @click="selectOption(option)"
        >
          {{ option.label }}
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import vClickOutside from 'click-outside-vue3';

export default {
  name: 'Select',
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    modelValue: {
      type: Object,
      required: false,
    },
    options: {
      type: Array,
      required: true,
    },
    default: {
      type: Object,
      required: false,
      default: null,
    },
    label: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    clear: {
      type: Boolean,
      required: false,
    },
  },
  emits: ['update:modelValue', 'change', 'clear-event', 'show-dropdown'],
  data() {
    return {
      dropdownIsShow: false,
    };
  },
  watch: {
    dropdownIsShow(val) {
      this.$emit('show-dropdown', val);

      if (!val) {
        setTimeout(() => {
          this.$refs.selectDropdown.classList.remove('top');
        }, 500);
      }
    },
  },
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },
  mounted() {
    this.model = this.default;
  },
  methods: {
    isElementOffScreen(element) {
      const rect = element.getBoundingClientRect();
      if (rect.bottom > window.innerHeight) {
        element.classList.add('top');
      } else {
        element.classList.remove('top');
      }
    },
    selectOption(option) {
      this.model = option;
      this.$emit('change', option);
    },
    showDropdown() {
      this.dropdownIsShow = !this.dropdownIsShow;

      this.$nextTick(() => {
        this.isElementOffScreen(this.$refs.selectDropdown);
      });
    },
    onClickOutside() {
      this.dropdownIsShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'styles';
</style>
